import * as LucideIcons from 'lucide-react'
import type { ComponentType, CSSProperties } from 'react'

interface Props {
	/** `lucide:Search` — иконка набора lucide по имени; `/icons/x.svg` — файл сайта; `https://…` — чужой файл. */
	icon?: string
	className: string
	size?: number
}

const LUCIDE_PREFIX = 'lucide:'

/** Иконка вкладки и карточки конструктора главной.
 *
 *  Иконка набора и файл сайта красятся цветом текста и одинаково живут в обеих темах (файл сайта — маской).
 *  Файл с чужого адреса маской не нарисовать: маске нужен CORS, иначе элемент молча исчезает, — поэтому он
 *  показывается картинкой как есть. Набор lucide уже в бандле главной (HomeTemp берёт из него иконки
 *  намерений по имени), так что новые иконки не добавляют веса. */
export default function BlockIcon({ icon, className, size = 22 }: Props) {
	if (!icon) return null
	if (icon.startsWith(LUCIDE_PREFIX)) {
		const Cmp = (LucideIcons as unknown as Record<string, ComponentType<{ size?: number; className?: string; strokeWidth?: number; 'aria-hidden'?: boolean }>>)[
			icon.slice(LUCIDE_PREFIX.length)
		]
		// Имя, которого в наборе нет (набор обновили, иконку переименовали), — просто без иконки.
		return Cmp ? <Cmp size={size} strokeWidth={1.4} className={`${className} is-glyph`} aria-hidden /> : null
	}
	if (!icon.startsWith('/')) {
		return <img className={`${className} is-img`} src={icon} alt="" aria-hidden="true" loading="lazy" decoding="async" />
	}
	return <span className={className} aria-hidden="true" style={{ '--icon': `url(${icon})` } as CSSProperties} />
}
